var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconBear = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.965 11.499a9.043 9.043 0 0 0-1.772-1.88 1.445 1.445 0 0 0-.341-.73A4.661 4.661 0 0 0 19.66 7.8a1.554 1.554 0 0 0-1.554-1.445 1.367 1.367 0 0 0-1.134 1.01C13.694 6.869 9.422 5.408 6.22 6.263a5.5 5.5 0 0 0-4.21 5.686 17.868 17.868 0 0 0 2.113 7.054c.166.522.648.879 1.196.886h2.828c0-.858-.696-1.554-1.554-1.554l.746-2.33c1.478.419 3.043.419 4.521 0l.482 2.827a1.274 1.274 0 0 0 1.243 1.072h2.828c0-.858-.696-1.553-1.554-1.553.466-1.134.699-1.725 1.274-3.108a8.204 8.204 0 0 1 1.756-3.123c.45.7 1.74.56 1.74.56h2.983a2.315 2.315 0 0 0 1.352-.917.264.264 0 0 0 0-.264z",
    fill: "#1A202C",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBear, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-bear.58bfb681.svg";
export { ForwardRef as ReactComponent };